import React, { useState, useEffect } from "react";
import "./Choosegarment.scss";
import Container from "../../Container/Container";
import Steppers from "../../components/Stepper/Stepper";
import { API, graphqlOperation, graphql } from "aws-amplify";
import { productData } from "../../store/action/index";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import Snackbar from "../../components/Snackbar/Snackbar";
import { useTranslation } from "react-i18next";
import { listGarments } from "../../graphql/queries";
import Modals from "../../components/Modal/Modal";
import { login } from "../../store/action/index";
import { selShirt } from "../../lib/helper";
import Garment from "./Garment";
import { productCategory } from "../../lib/helper";
import { listProductCategorys } from "../../graphql/queries";

const Choosegarments = (props) => {
	const { t } = useTranslation();
	const product = useSelector((state) => state.product);

	const dispatch = useDispatch();
	const [item, setItem] = useState("Tout");
	const [openmodal, setopenmodal] = useState(false);
	const [tgarments, settgarments] = useState([]);
	const history = useHistory();
	const [msg, setMsg] = useState("");
	const [errMsg, setErrMsg] = useState("");
	const [prodCat, setProdCat] = useState([]);
	const [front, setFront] = useState("");
	const [back, setBack] = useState("");

	const garmentsData = async () => {
		try {
			const garmentslist = await API.graphql({
				query: listGarments,
				authMode: "API_KEY",
			});
			settgarments(
				garmentslist.data.listGarments.items.sort((a, b) => a.cost - b.cost),
			);
		} catch (error) {
			setErrMsg(error.message);
		}
	};

	useEffect(() => {
		garmentsData();
		productCategory(API, graphql, listProductCategorys, setProdCat);
		dispatch(
			productData({
				step: 1,
				edit: false,
			}),
		);
	}, []);

	function toDataURL(url, callback) {
		var xhr = new XMLHttpRequest();
		xhr.onload = function () {
			var reader = new FileReader();
			reader.onloadend = function () {
				callback(reader.result);
			};
			reader.readAsDataURL(xhr.response);
		};
		url += "?" + new Date().getTime();
		xhr.open("GET", url);
		xhr.responseType = "blob";
		xhr.send();
	}

	useEffect(() => {
		const data = localStorage.getItem("email");
		if (data) {
			dispatch(
				login({
					loginStatus: true,
					userDetail: data,
				}),
			);
		}
	}, []);

	const designroute = () => {
		setErrMsg("");
		dispatch(
			productData({
				step: 0,
			}),
		);

		if (product.shirt.frontshirturl) {
			history.push("/design");
		} else {
			setErrMsg(t("Kindly_Choose_a_Fabric"));
			setTimeout(() => {
				setErrMsg("");
			}, 2000);
		}
	};

	return (
		<Container>
			<Steppers
				head={t("choose_garments")}
				text={t("continue")}
				continue={() => designroute()}
				uploadfunc={() => setopenmodal(true)}
				prev
				login={true}
			/>
			{tgarments.length ? (
				<div className="choosegarment">
					<div className="shirts">
						<div className="items">
							<ul>
								<li
									className={`${item === t("all") && "clr_black"}`}
									onClick={(e) => {
										setItem(e.target.innerHTML);
									}}
								>
									{t("all")}
								</li>
								{prodCat.map((data, ind) => {
									return (
										<li
											className={`${item === data.id && "clr_black"}`}
											key={ind}
											onClick={(e) => setItem(data.id)}
										>
											{data.categoryName}
										</li>
									);
								})}
							</ul>
						</div>
						<div className="images">
							<>
								{tgarments?.map((data, ind) => {
									return item === t("all") ? (
										<div key={ind} className="shirt_center cp">
											<Garment
												onClick={() => {
													selShirt({
														setFront,
														setBack,
														dispatch,
														productData,
														toDataURL,
														data,
													});
												}}
												data={data}
											/>
										</div>
									) : (
										data.category.map(
											(cat) =>
												cat.id === item && (
													<div key={ind} className="shirt_center cp">
														<Garment
															onClick={() => {
																selShirt({
																	setFront,
																	setBack,
																	dispatch,
																	productData,
																	toDataURL,
																	data,
																});
															}}
															data={data}
														/>
													</div>
												),
										)
									);
								})}
							</>
						</div>

						<div className="selected-shirt">
							{product.shirt.backshirturl && product.shirt.frontshirturl ? (
								<>
									<h4>{t("selected_fabric")}</h4>
									<img
										src={product.shirt.frontshirturl}
										width={200}
										height={200}
										className="selshirt"
										alt="shirt"
									/>
								</>
							) : null}
						</div>
					</div>
				</div>
			) : (
				<div className="no-garments">
					<h1>{t("no-garment")}</h1>
				</div>
			)}
			<Modals
				condition="garments"
				setopenmodal={{ setopenmodal }}
				openmodal={openmodal}
				settgarments={settgarments}
				tgarments={tgarments}
			/>

			{msg || errMsg ? <Snackbar message={msg} errMessage={errMsg} /> : null}
		</Container>
	);
};
export default Choosegarments;
